module.exports = __webpack_public_path__ + "img/banner5.997df612.jpg";